/**
 * Transflo.WorkflowDefinition.HttpApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PrePopulatedTypeEnum = 'JSON' | 'RegField' | 'ExternAPI' | 'WFComp';

export const PrePopulatedTypeEnum = {
    Json: 'JSON' as PrePopulatedTypeEnum,
    RegField: 'RegField' as PrePopulatedTypeEnum,
    ExternApi: 'ExternAPI' as PrePopulatedTypeEnum,
    WfComp: 'WFComp' as PrePopulatedTypeEnum
};

